<div *ngIf="currentLoc !== 7">
  <div class="page-header">
    <div class="grid-container">
      New  {{getDomainType() | titlecase}} Top-Level Domain Delegation
    </div>
  </div>

  <div class="grid-container">
  <nav aria-label="You are here:" role="navigation">
    <ul class="breadcrumb">
      <li *ngIf="revealedLoc >= 0">
        <a (click)="goTo(0)">{{getTabNameBasedOnGivenLocation(0)}}</a>
      </li>
      <li *ngIf="revealedLoc >= 1">
        <a (click)="goTo(1)">{{getTabNameBasedOnGivenLocation(1)}}</a>
      </li>
      <li *ngIf="revealedLoc >= 2">
        <a (click)="goTo(2)">{{getTabNameBasedOnGivenLocation(2)}}</a>
      </li>
      <li *ngIf="revealedLoc >= 3">
        <a (click)="goTo(3)">{{getTabNameBasedOnGivenLocation(3)}}</a>
      </li>
      <li *ngIf="revealedLoc >= 4">
        <a (click)="goTo(4)">{{getTabNameBasedOnGivenLocation(4)}}</a>
      </li>
      <li *ngIf="revealedLoc >= 5">
        <a (click)="goTo(5)">{{getTabNameBasedOnGivenLocation(5)}}</a>
      </li>
      <li *ngIf="revealedLoc >= 6">
        <a (click)="goTo(6)">{{getTabNameBasedOnGivenLocation(6)}}</a>
      </li>
    </ul>
  </nav>
  <div class="content-header">{{getTabName()}}</div>
  <div class="header-helper" [innerHTML]="getTabDescription()"></div>

  <div class="content content-with-elevation">
    <domain-type *ngIf="currentLoc === 0" [isCreatingDomain]="isCreatingDomain" [domainType]="topLevelDomain?.type" [domainName]="topLevelDomain?.name"
                 (domainTypeOutput)="domainTypeOutput($event)"
                 (cancelOutPut)="cancel($event)"></domain-type>

    <sponsoring-org-edit *ngIf="currentLoc === 1" [newDelegation]="true"
                         [organizationVO]="topLevelDomain?.organization"
                         (sponsoringOrgVOOutput)="sponsoringOrgOutput($event)"
                         (cancelOutPut)="cancel($event)"></sponsoring-org-edit>

    <contact-info-edit *ngIf="currentLoc === 2" [newDelegation]="true" [contactVO]="topLevelDomain?.administrative"
                       (contactVOOutput)="contactACOutPut($event)" (cancelOutPut)="cancel($event)"></contact-info-edit>

    <contact-info-edit *ngIf="currentLoc === 3" [newDelegation]="true" [contactVO]="topLevelDomain?.technical"
                       (contactVOOutput)="contactTCOutPut($event)" (cancelOutPut)="cancel($event)"></contact-info-edit>

    <name-servers-edit *ngIf="currentLoc === 4" [newDelegation]="true" [nameServers]="topLevelDomain?.nameServers" [tldName]="topLevelDomain?.name"
                       (cancelOutPut)="cancel($event)"
                       (nameServersEventOutPut)="nameServerOutPut($event)"></name-servers-edit>

    <lib-ds-records-edit *ngIf="currentLoc === 5" [newDelegation]="true" [trustAnchors]="topLevelDomain?.trustAnchors"
                        (trustAnchorsEventOutPut)="trustAnchorsOutput($event)"
                        (cancelOutPut)="cancel($event)"></lib-ds-records-edit>

    <sub-domain-info-edit *ngIf="currentLoc === 6" [newDelegation]="true" [domain]="topLevelDomain"
                          (domainVOOutPut)="domainOutPut($event)"
                          (cancelOutPut)="cancel($event)"></sub-domain-info-edit>
  </div>


</div>
</div>
<create-request *ngIf="currentLoc === 7" [name]="topLevelDomain?.name" [newDelegation]="true"
                [domain]="topLevelDomain" [requestMetadata]="requestMetadata"></create-request>

